import { Action } from '@ngrx/store'

export enum RequireInternationalDataGuardActionTypes {
  InternationalDataNotFound = '[RequireInternationalDataGuard] InternationalData NotFound',
}

export class InternationalDataNotFound implements Action {
  readonly type = RequireInternationalDataGuardActionTypes.InternationalDataNotFound

  constructor(public url: string) {}
}

export type RequireInternationalDataGuardActions = InternationalDataNotFound
